import React, { useState, useEffect, useRef } from "react";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { makeStyles, Paper, Tabs, Tab } from "@material-ui/core";

import TabPanel from "../../components/TabPanel";

import SchedulesForm from "../../components/SchedulesForm";
// import CompaniesManager from "../../components/CompaniesManager"; // ✅ NO USADO - Reemplazado por CompaniesManagerImproved
import CompaniesManagerImproved from "../../components/CompaniesManager/CompaniesManagerImproved";
// import HelpsManager from "../../components/HelpsManager"; // ✅ NO USADO - Reemplazado por HelpsManagerImproved
import HelpsManagerImproved from "../../components/HelpsManager/HelpsManagerImproved";
import Options from "../../components/Settings/Options";
import ThemeSelector from "../../components/Settings/ThemeSelector";
import SubscriptionsConfig from "../../components/Settings/SubscriptionsConfig";
import WebConfig from "../../components/Settings/WebConfig";
import VersionInfo from "../../components/Settings/VersionInfo";
import PlatformIntegrations from "../../components/Settings/PlatformIntegrations";
import { useLocation } from "react-router-dom";
// ✅ NUEVO: Componente para notificaciones VPS
import NotificationAlertsConfig from "../Settings/components/NotificationAlertsConfig";

import { i18n } from "../../translate/i18n.js";
import { toast } from "react-toastify";

import useCompanies from "../../hooks/useCompanies";
import useAuth from "../../hooks/useAuth.js";
import useSettings from "../../hooks/useSettings";

import OnlyForSuperUser from "../../components/OnlyForSuperUser";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  /**
   * El marco: NO scrollea. Solo reparte el alto entre las pestañas y el contenido.
   *
   * Antes tenía `overflowY: scroll` y las pestañas iban dentro, así que al bajar por
   * una pestaña larga —Suscripciones, Web, Empresas— la botonera se iba con el
   * contenido y había DOS barras de scroll anidadas peleándose.
   *
   * `minHeight: 0` no es adorno: sin él, un hijo flex nunca se encoge por debajo de
   * su contenido y el scroll interior no llega a activarse.
   */
  mainPaper: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: Estilos para contenedor de Tabs
  tabsContainer: {
    flexShrink: 0, // la botonera se queda arriba, pase lo que pase debajo
    backgroundColor: theme.palette.background.paper,
    "& .MuiTabs-root": {
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider || (theme.mode === 'dark' ? '#374151' : '#e0e0e0')}`,
    },
    "& .MuiTabs-flexContainer": {
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiTab-root": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      },
      "&.Mui-selected": {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.background.paper,
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  tab: {
    backgroundColor: theme.palette.options,
    borderRadius: 4,
  },
  /**
   * Aquí y solo aquí se scrollea.
   *
   * 🔴 `display: flex` + `alignItems: center` era el motivo de que el contenido alto
   * "no se ajustara a la pantalla": un hijo flex centrado que desborda se sale por
   * ARRIBA, y esa parte queda inalcanzable — el scroll no sube hasta ella. Con
   * `block` el contenido empieza donde debe y se recorre entero.
   *
   * `overflowX: auto` da salida a las tablas anchas (Planes, Empresas) en vez de
   * dejarlas cortadas.
   */
  paper: {
    ...theme.scrollbarStyles,
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "auto",
    padding: theme.spacing(2),
    display: "block",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    width: "100%",
  },
  control: {
    padding: theme.spacing(1),
  },
  textfield: {
    width: "100%",
  },
}));

const SettingsCustom = () => {
  const classes = useStyles();
  // ?tab=integrations&canal=instagram: el aviso de Conexiones lleva directo a la tarjeta del canal (0440).
  const query = new URLSearchParams(useLocation().search);
  const [tab, setTab] = useState(query.get("tab") || "options");
  const canalFoco = query.get("canal");
  const [schedules, setSchedules] = useState([]);
  const [company, setCompany] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [settings, setSettings] = useState({});
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);

  const { getCurrentUserInfo } = useAuth();
  const { find, updateSchedules } = useCompanies();
  const { getAll: getAllSettings } = useSettings();

  useEffect(() => {
    async function findData() {
      setLoading(true);
      try {
        const companyId = localStorage.getItem("companyId");
        const company = await find(companyId);
        const settingList = await getAllSettings();
        setCompany(company);
        setSchedules(company.schedules);
        setSettings(settingList);

        if (Array.isArray(settingList)) {
          const scheduleType = settingList.find(
            (d) => d.key === "scheduleType"
          );
          if (scheduleType) {
            setSchedulesEnabled(scheduleType.value === "company");
          }
        }

        const user = await getCurrentUserInfo();
        setCurrentUser(user);
      } catch (e) {
        toast.error(e);
      }
      setLoading(false);
    }
    findData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** Contenedor que scrollea; se reinicia al cambiar de pestaña. */
  const contenidoRef = useRef(null);

  const handleTabChange = (event, newValue) => {
      async function findData() {
        setLoading(true);
        try {
          const companyId = localStorage.getItem("companyId");
          const company = await find(companyId);
          const settingList = await getAllSettings();
          setCompany(company);
          setSchedules(company.schedules);
          setSettings(settingList);
  
          if (Array.isArray(settingList)) {
            const scheduleType = settingList.find(
              (d) => d.key === "scheduleType"
            );
            if (scheduleType) {
              setSchedulesEnabled(scheduleType.value === "company");
            }
          }
  
          const user = await getCurrentUserInfo();
          setCurrentUser(user);
        } catch (e) {
          toast.error(e);
        }
        setLoading(false);
      }
      findData();
      // eslint-disable-next-line react-hooks/exhaustive-deps

    setTab(newValue);
    // Cada pestaña es una pantalla distinta: empieza arriba. Sin esto se abre a la
    // altura a la que quedó la anterior y parece que falta contenido.
    if (contenidoRef.current) contenidoRef.current.scrollTop = 0;
  };

  const handleSubmitSchedules = async (data) => {
    setLoading(true);
    try {
      setSchedules(data);
      await updateSchedules({ id: company.id, schedules: data });
      toast.success(i18n.t("settings.schedules.success"));
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  };

  const isSuper = () => {
    return currentUser.super;
  };

  // 0390 FT-5 — quién ve la pestaña de apariencia. La autoridad real es el
  // backend, que exige `settings:administrar` en `PUT /theme/company`: esto solo
  // evita mostrar una pestaña que acabaría en un 403.
  const puedeAdministrar = () => {
    return Boolean(currentUser.super) || currentUser.profile === "admin";
  };

  return (
    <MainContainer className={classes.root}>
      <MainHeader>
        <Title>{i18n.t("settings.title")}</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} elevation={1}>
        <div className={classes.tabsContainer}>
          <Tabs
            key={i18n.language}
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="on"
            variant="scrollable"
            onChange={handleTabChange}
          >
            <Tab label={i18n.t("settings.tabs.options")} value={"options"} />
            {/* 0390 FT-5 — el tema alcanza a toda la empresa: solo quien administra */}
            {puedeAdministrar() ? <Tab label="Apariencia" value={"appearance"} /> : null}
            {schedulesEnabled && <Tab label={i18n.t("settings.tabs.schedules")} value={"schedules"} />}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.version")} value={"version"} /> : null}
            {isSuper() ? <Tab label="Integraciones" value={"integrations"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.alerts")} value={"alerts"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.subscriptions")} value={"subscriptions"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.logo")} value={"web"} /> : null}
            {/* ✅ ELIMINADO: Tab "Rendimiento" movido a Dashboard > Rendimiento CPU */}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.companies")} value={"companies"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.help")} value={"helps"} /> : null}
          </Tabs>
        </div>
        <Paper className={classes.paper} elevation={0} ref={contenidoRef}>
          {/* 0390 FT-5 — selector de tema de la empresa */}
          <TabPanel className={classes.container} value={tab} name={"appearance"}>
            <ThemeSelector />
          </TabPanel>
          <TabPanel
            className={classes.container}
            value={tab}
            name={"schedules"}
          >
            <SchedulesForm
              loading={loading}
              onSubmit={handleSubmitSchedules}
              initialValues={schedules}
            />
          </TabPanel>
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel
                className={classes.container}
                value={tab}
                name={"companies"}
              >
                <CompaniesManagerImproved />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel
                className={classes.container}
                value={tab}
                name={"helps"}
              >
                <HelpsManagerImproved />
              </TabPanel>
            )}
          />
          <TabPanel className={classes.container} value={tab} name={"options"}>
            <Options
              settings={settings}
              scheduleTypeChanged={(value) =>
                setSchedulesEnabled(value === "company")
              }
            />
          </TabPanel>
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"version"}>
                <VersionInfo />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"integrations"}>
                <PlatformIntegrations focus={canalFoco} />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"alerts"}>
                <NotificationAlertsConfig />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"subscriptions"}>
                <SubscriptionsConfig />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"web"}>
                <WebConfig />
              </TabPanel>
            )}
          />
          {/* ✅ ELIMINADO: TabPanel "performance" movido a Dashboard > Rendimiento CPU */}
        </Paper>
      </Paper>
    </MainContainer>
  );
};

export default SettingsCustom;
